// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1319":"68fe4737","2480":"3b42e7c7","3943":"6b53e212","8386":"2483ecc5"}[chunkId] || chunkId) + "." + {"1319":"8549ca7dc9773055","2480":"a59ecec33aaa91da","3943":"f17b1d5024bd4735","5173":"71d2c82d91465ee5","6000":"14625556d335ebfc","8386":"42621b182e035fdb","9777":"f2d3df014b46fd5a"}[chunkId] + ".js";
};